<template>
  <user-center-wrap>
    <div class="history">
      <div class="header">观看历史</div>
      <div class="tabs">
        <div class="tabs-left">
          <div class="tab" @click="changeList(true, 1)">
            <div class="tab-up" :class="activeTab ? 'tab-up-active' : ''">全部</div>
            <div class="tab-down" v-show="activeTab"></div>
          </div>
          <div class="tab" @click="changeList(false, 2)">
            <div class="tab-up" :class="!activeTab ? 'tab-up-active' : ''">直播中</div>
            <div class="tab-down" v-show="!activeTab"></div>
          </div>
        </div>
        <div class="tabs-right" @click="dialogVisible = true">
          <img src="./img/clear.png" alt="" />
          <div>清空历史</div>
        </div>
      </div>
      <div class="content">
        <div class="no-data" v-show="!dataList">
          <img src="./img/no_data.png" alt="" />
          <div>还没有任何记录哦，</div>
          <div>快去看直播吧</div>
        </div>
        <router-link
          :to="`/liveMatchesTwo/${item.anchorid}`"
          target="_blank"
          v-show="dataList"
          class="list"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <div class="list-left">
            <img class="list-left-cover" :src="item.thumb" alt="" />
            <img class="list-left-live" v-show="item.is_live" src="./img/live.png" alt="" />
          </div>
          <div class="list-right">
            <div class="list-right-up text-overflow">{{ item.title }}</div>
            <div class="list-right-mid">
              <div class="first">{{ item.child_category_name }}</div>
              <div class="second"></div>
              <div class="third text-overflow">主播：{{ item.anchor_name }}</div>
            </div>
            <div class="list-right-down">
              <img v-show="item.platform == 1" class="first" src="./img/pc.png" alt="" />
              <img v-show="item.platform != 1" class="first" src="./img/phone.png" alt="" />
              <div class="second">{{ moment(item.last_visit_time * 1000).format("MM-DD HH:mm:ss") }}</div>
              <img class="third" v-show="item.is_favorite" src="./img/like.png" alt="" />
              <img class="third" v-show="!item.is_favorite" src="./img/like_off.png" alt="" />
            </div>
          </div>
        </router-link>
      </div>
      <div class="pages" v-show="dataList">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageNum"
          :total="totalCount"
          @current-change="handleCurrentChange"
          :current-page="page"
        >
        </el-pagination>
      </div>
      <el-dialog top="30vh" class="watch-dialog" center :visible.sync="dialogVisible" width="25%">
        <div class="dia-content">
          <span>确定清空所有观看历史？</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="cancel" @click="dialogVisible = false" round>取 消</el-button>
          <el-button class="commit" type="primary" round @click="clearHistoy()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "../../../components/user-center-wrap/user-center-wrap";
import { post } from "../../../util/http";
import moment from "moment";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "watchHistory",
  components: {
    UserCenterWrap,
  },
  data() {
    return {
      moment: moment,
      activeTab: true,
      isLive: 1,
      dataList: [],
      page: 1,
      pageNum: 10,
      totalCount: 0,
      isShowDetail: true,
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.getWatchHistory();
  },
  methods: {
    async getWatchHistory() {
      const {
        data: { data },
      } = await post({
        url: "/api/live/visit_list",
        data: { page: this.page, size: this.pageNum, status: this.isLive, user_id: this.userInfo.id },
      });
      this.dataList = data.LiveVisit;
      this.totalCount = data.total;
    },
    changeList(boo, val) {
      this.activeTab = boo;
      this.isLive = val;
      this.getWatchHistory();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getWatchHistory();
    },
    async clearHistoy() {
      this.dialogVisible = false;
      const {
        data: { status },
      } = await post({
        url: "/api/live/visit_clean",
        data: { user_id: this.userInfo.id },
      });
      if (status == 0) {
        this.$message.success("清空成功");
        location.reload();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.history {
  width: 100%;
  height: 100%;
  padding: 0.28rem 0.44rem;
}
.header {
  font-size: 0.2rem;
  color: #333333;
  font-weight: 500;
  margin-bottom: 0.4rem;
}
.tabs {
  display: flex;
  justify-content: space-between;
  border-bottom: 0.01rem solid #f0f0f0;

  .tabs-left {
    width: 3rem;
    display: flex;
    .tab {
      height: 0.35rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin-right: 0.22rem;
      .tab-up {
        font-weight: 400;
        font-size: 0.16rem;
        color: #333333;
      }
      .tab-up-active {
        color: #02a8a2;
      }
      .tab-down {
        width: 0.2rem;
        height: 0.04rem;
        border-radius: 0.04rem;
        background: #02a8a2;
      }
    }
  }
  .tabs-right {
    display: flex;
    align-items: center;
    font-size: 0.12rem;
    color: #666;
    cursor: pointer;
    img {
      width: 0.2rem;
      height: 0.2rem;
      margin-right: 0.03rem;
    }
  }
}
.content {
  padding-top: 0.16rem;
  display: flex;
  flex-wrap: wrap;
  .no-data {
    width: 100%;
    text-align: center;
    margin-top: 20%;
    color: #a9a9a9;
    font-size: 0.16rem;
    line-height: 0.19rem;
    img {
      width: 1.8rem;
      height: 1.8rem;
    }
  }
  .list {
    display: flex;
    margin-bottom: 0.2rem;
    margin-right: 0.2rem;
    cursor: pointer;
    .list-left {
      position: relative;
      width: 1rem;
      height: 1rem;
      .list-left-cover {
        width: 1rem;
        height: 1rem;
        border-radius: 0.05rem 0 0 0.05rem;
        object-fit: cover;
      }
      .list-left-live {
        position: absolute;
        top: 0;
        right: 0;
        width: 0.46rem;
        height: 0.18rem;
      }
    }
    .list-right {
      width: 2.8rem;
      height: 1rem;
      background: #f4f4f4;
      border-radius: 0px 0.05rem 0.05rem 0;
      display: flex;
      flex-direction: column;
      padding: 0.16rem 0.1rem 0.1rem;
      .list-right-up {
        font-weight: 500;
        font-size: 0.14rem;
        line-height: 0.2rem;
        color: #333333;
        margin-bottom: 0.05rem;
      }
      .list-right-mid {
        display: flex;
        align-items: center;
        font-size: 0.12rem;
        color: #333333;
        .first {
          color: #02a8a2;
        }
        .second {
          width: 0.01rem;
          height: 0.1rem;
          background: #999999;
          border-radius: 0.1rem;
          margin: 0 0.05rem;
        }
        .third {
          flex: 1;
        }
      }
      .list-right-down {
        display: flex;
        align-items: center;
        margin-top: 0.15rem;
        .first {
          width: 0.12rem;
          height: 0.12rem;
          margin-right: 0.05rem;
        }
        .second {
          color: #999999;
          font-size: 0.12rem;
          flex: 1;
        }
        .third {
          width: 0.16rem;
          height: 0.16rem;
        }
      }
    }
  }
}
.pages {
  text-align: center;
  margin-top: 0.3rem;
}
::v-deep .el-dialog__header {
  border-bottom: 0.01rem solid #f0f0f0;
}
.el-dialog__close {
  color: #d9d9d9;
}
.watch-dialog {
  ::v-deep .el-dialog__header {
    display: none;
  }
  .dia-content {
    padding: 0.2rem 0.2rem;
    padding-top: 0.3rem;
    color: #333333;
    font-size: 0.18rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cancel,
  .cancel:hover {
    border-color: #02a8a2;
    color: #02a8a2;
    padding: 0.1rem 0.45rem;
  }
  .commit,
  .commit:hover {
    background-color: #02a8a2;
    color: #ffffff;
    border-color: #02a8a2;
    padding: 0.1rem 0.45rem;
  }
}
</style>
